export default __webpack_public_path__ + "static/media/406.3838d232.jpg";